import React, { useState, useContext, useEffect } from 'react';
import { IconButton, Badge, Menu, MenuItem } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { MdNotifications } from "react-icons/md";
import LogContext from 'context/log/logContext';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import MenuNotificaciones from "./MenuNotificaciones"

export default function CampanaNotificaciones() {
    const logContext = useContext(LogContext);
    const { obtenerLogs } = logContext;
    const [ eventos, setEventos ] = useState()
    //const eventos =[];
    
    const doFetch = async () => {
       try {
        const response = await obtenerLogs(null, "count", "totales");
        return response.cantidadNotificacionesTotales || 0;
       }catch(e){
        
       }
    }

    const onRefresh = () => {
        doFetch().then( cant => {
            if (cant) {
                setEventos(cant > 99 ? "99+" : cant)
            }
        });
    };

    useEffect(() => {
        //TODO: descomentar 
        onRefresh()
        const interval = setInterval(() => {
            onRefresh();
        }, 300*1000);// 300000ms == 5 min
        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, []);

    document.title = eventos ?
        (eventos > 0 ?
            "(" + eventos + ") Pampa4"
            :
            "Pampa4")
        : "Pampa4"

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };
    
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div  style={{marginTop:"0.2em"}}>
            <Tooltip arrow title={<p style={{ fontSize: "12px", minWidth: 70, textAlign: "center" }}> Notificaciones</p>}>
                <IconButton
                    color="inherit"
                    aria-describedby={id}
                    onClick={handleClick
                        /*
                        Campana Principal (conteo global)
                        () => {
                        handleMenu()
                        //history.push("/supervisor")
                    } */}
                >
                    <Badge badgeContent={eventos} color="secondary">
                        <MdNotifications style={{ color: "#FAFAFA" }} />
                    </Badge>
                </IconButton>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <MenuNotificaciones close={handleClose}/>
            </Popover>

        </div>
    );
}

